import { POSTHOG_AB_PREFIX } from '@/utils/analytics/posthog/utils';

// list of Lex keys to evaluate. Please actively remove the key if it's been cleaned up completely
// For posthog feature flags, use the `POSTHOG_AB_PREFIX` prefix like this: `TEST_FLAG = `${POSTHOG_AB_PREFIX}test-flag`,
export enum LexSlug {
  FEATURE_APPLICANT_USE_CREDITS = 'feature-applicant-use-credits',
  FEATURE_INBOX_DETAILS_SIDEBAR = 'feature-inbox-details-sidebar',
  FEATURE_CANCEL_PAUSE_SUBSCRIPTION = 'feature-cancel-pause-subscription',
  LINKEDIN_UPSELL = 'linkedin-upsell',
  FEATURE_COACHING_REQUEST = 'feature-coaching-request',
  UPGRADE_PACKAGE_FLOW = 'upgrade-package-flow',
  FEATURE_CUSTOMER_REFERRAL = 'feature-customer-referral',
  FEATURE_MULTI_EVENT_REGISTRATION = 'feature-multi-event-registration',
  GUEST_CHECKOUT = 'guest-checkout',
  LELAND_PLUS_CHECKOUT_ON_STACK = 'leland-plus-checkout-on-stack',
  GUEST_EVENT_SIGNUP_AB_ENABLED = `${POSTHOG_AB_PREFIX}guest-event-signup-enabled`,
  SAVING_COACHES_AB_ENABLED = `${POSTHOG_AB_PREFIX}saving-coaches`,
  RECOMMENDED_OFFERINGS_REVAMP = 'recommended-offering-revamp',
  RECOMMENDED_OFFERINGS_REVAMP_AB_ENABLED = `${POSTHOG_AB_PREFIX}${RECOMMENDED_OFFERINGS_REVAMP}`,
  UPDATE_VOUCH_FLOW = 'update-vouch-flow',
  BOOTCAMPS_REVIEWS_AND_MEETINGS = 'bootcamps-reviews-and-meetings',
  MIGRATE_AUTH = 'migrate-auth',
  LELAND_PLUS_ON_STACK = 'leland-plus-on-stack',
  SHOW_OLD_LELAND_PLUS_BUTTON = 'show-old-leland-plus-button',
  EVENTS_LANDING_PAGE = 'events-landing-page',
}
